import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PackingTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PackingTypeCreateDto,
  PackingTypeDto,
  PackingTypeExcelDownloadDto,
  PackingTypeUpdateDto,
} from '../proxy/planning/dtos/packing-type';
import { PACKINGTYPE_CONFIG, PACKINGTYPE_FIELDS } from './packing-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-packing-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PackingTypeService, ConfirmationService],
  templateUrl: './packing-type.html',
  styleUrl: './packing-type.scss',
})
export class PackingType extends BaseCrudComponent<
  PackingTypeDto,
  PackingTypeCreateDto,
  PackingTypeUpdateDto,
  PackingTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PackingTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PackingType', ids),
  };
  config = PACKINGTYPE_CONFIG;
  fields = PACKINGTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PackingTypeDto): PackingTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PackingType';
  }
}
